import { storeReduxStateToLocalStorage } from '@src/modules/local_storage_utils';
import store from '@src/store/index';
import throttle from 'lodash-es/throttle';
import { useEffect } from 'react';

/**
 * Redux ストアの変更を監視してローカルストレージに永続化するフック。
 * パフォーマンス最適化のため、スロットリングを適用して呼び出し頻度を制限します。
 */
export const useReduxPersistence = (): void => {
  useEffect(() => {
    // 永続化処理をスロットリング（1秒間に最大1回実行）
    const throttledPersistence = throttle(
      () => {
        storeReduxStateToLocalStorage(store.getState());
      },
      1000,
      { leading: false, trailing: true }
    );

    const unsubscribe = store.subscribe(throttledPersistence);

    return () => {
      unsubscribe();
      throttledPersistence.cancel();
    };
  }, []);
};
